var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2436_5553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0.5H0V16.5H16V0.5Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 15.1667C9.84158 15.1667 11.5083 14.4205 12.7147 13.2141C13.9211 12.0076 14.6673 10.341 14.6673 8.50004C14.6673 6.65911 13.9211 4.99244 12.7147 3.78599C11.5083 2.57957 9.84158 1.83337 8.00065 1.83337C6.15972 1.83337 4.49305 2.57957 3.2866 3.78599C2.08018 4.99244 1.33398 6.65911 1.33398 8.50004C1.33398 10.341 2.08018 12.0076 3.2866 13.2141C4.49305 14.4205 6.15972 15.1667 8.00065 15.1667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 8.5L7.33398 10.5L11.334 6.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2436_5553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleOutlined);
export default __webpack_public_path__ + "static/media/check-circle-outlined.1724663984f7880b2c63b22e520c3eb4.svg";
export { ForwardRef as ReactComponent };